import { ItemsChartModalEditor } from "./ItemsChartModal";

export function FunnelChartEditor({ block }) {
  return <ItemsChartModalEditor block={block} chartType="funnel-chart" />;
}
